import { render, staticRenderFns } from "./selectReletionsOnBoarding.vue?vue&type=template&id=35523a86&scoped=true&"
import script from "./selectReletionsOnBoarding.vue?vue&type=script&lang=js&"
export * from "./selectReletionsOnBoarding.vue?vue&type=script&lang=js&"
import style0 from "./selectReletionsOnBoarding.vue?vue&type=style&index=0&id=35523a86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35523a86",
  null
  
)

export default component.exports